// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"DashboardCard_cardContainer__1ylZ-","cardValue":"DashboardCard_cardValue__1qucY","cardDescription":"DashboardCard_cardDescription__1X6t3"};